<template>
  <div>
    <a v-if="isLink" :href="url" :class="linkClass">
      {{ displayText }}<span v-if="isStoryFooterCta"> &rarr;</span>
    </a>
    <a v-if="isButton" :href="url" class="link link--button">
      {{ text }}
    </a>
  </div>
</template>
<script src="./link.js"></script>
<style src="./link.scss" lang="scss"></style>
